import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as locationSelectors from 'state/selectors/locationSelectors';
import Header from './Header';
import SummaryList from './SummaryList';
import AddLocationInformationForm from '../address-information/Fields';

const LocationInformationSection = ({
  values,
  touched,
  errors,
  resetLocationValues,
  isAddressVerifyPass,
  setIsAddressVerifyPass,
  setFieldValue,
  setFieldError,
  setFieldTouched,
  isShowAddressVerifyTip,
  setShowAddressVerifyTip,
  isHasPrivateLocation,
  isEditLocation,
  setIsEditLocation,
  setValues,
  addressMandatory,
  handleBlur
}) => (
  <div className="col-md-8">
    <Header
      isShowAddressVerifyTip={isShowAddressVerifyTip}
      values={values}
      addressMandatory={addressMandatory}
    />
    {isAddressVerifyPass ? (
      <SummaryList
        resetLocationValues={resetLocationValues}
        setIsAddressVerifyPass={setIsAddressVerifyPass}
        isHasPrivateLocation={isHasPrivateLocation}
        setIsEditLocation={setIsEditLocation}
        isAddressVerifyPass={isAddressVerifyPass}
        {...{ setFieldValue }}
      />
    ) : (
      <AddLocationInformationForm
        isFullLocationPage={false}
        setFieldError={setFieldError}
        resetLocationValues={resetLocationValues}
        isAddressVerifyPass={isAddressVerifyPass}
        setIsAddressVerifyPass={setIsAddressVerifyPass}
        setShowAddressVerifyTip={setShowAddressVerifyTip}
        isOpenEditLocation={isEditLocation}
        addressMandatory={addressMandatory}
        {...{ values, touched, errors, setValues, setFieldValue, setFieldError, setFieldTouched, handleBlur }}
      />
    )}
  </div>
);

LocationInformationSection.propTypes = {
  values: PropTypes.shape().isRequired,
  touched: PropTypes.shape().isRequired,
  errors: PropTypes.shape().isRequired,
  resetLocationValues: PropTypes.func.isRequired,
  isEditLocation: PropTypes.bool.isRequired,
  setIsEditLocation: PropTypes.func.isRequired,
  addressMandatory: PropTypes.bool.isRequired,
  isShowAddressVerifyTip: PropTypes.bool.isRequired,
  setShowAddressVerifyTip: PropTypes.func.isRequired,
  isAddressVerifyPass: PropTypes.bool.isRequired,
  setIsAddressVerifyPass: PropTypes.func.isRequired,
  isHasPrivateLocation: PropTypes.bool.isRequired,
  handleBlur: PropTypes.func.isRequired,
};

export default LocationInformationSection;
